var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71851 6.86385C9.22677 7.24386 8.50956 7.79812 7.98387 7.78905C7.45818 7.79812 6.74097 7.24386 6.24923 6.86384C6.14757 6.78528 6.05554 6.71416 5.97683 6.65701C2.61374 4.21641 2.1305 3.83824 1.41159 3.27564C1.35485 3.23124 1.29665 3.18569 1.23545 3.1379C1.07687 3.0121 0.983887 2.82344 0.983887 2.62109V2.10156C0.983887 1.37695 1.57178 0.789062 2.29638 0.789062H13.6714C14.396 0.789062 14.9839 1.37695 14.9839 2.10156V2.62109C14.9839 2.82344 14.8909 3.01485 14.7323 3.1379L14.5518 3.27955L14.4372 3.36952L14.3804 3.41396L14.2662 3.5031C13.651 3.98215 12.8937 4.55045 9.99091 6.65701C9.9122 6.71416 9.82017 6.78528 9.71851 6.86385ZM14.9839 9.97701C14.9839 10.7016 14.396 11.2895 13.6714 11.2895H2.29638C1.57178 11.2895 0.983887 10.7016 0.983887 9.97701V4.38795C0.983887 4.25123 1.13975 4.17467 1.24913 4.25945C1.86161 4.73522 2.67372 5.33953 5.46278 7.36569C5.55025 7.42953 5.64682 7.50405 5.75113 7.58453C6.33482 8.03491 7.16033 8.67188 7.98387 8.66724C8.81124 8.67421 9.65038 8.02509 10.2249 7.58063C10.3283 7.50069 10.4231 7.42738 10.5077 7.36569C13.2967 5.33953 14.1061 4.7325 14.7186 4.2567C14.8253 4.17195 14.9839 4.25123 14.9839 4.38523V9.97701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.8accd32dc8658878a5cec9392a50cb2f.svg";
export { ForwardRef as ReactComponent };